import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { AuthService } from '../shared/service/auth.service';
import { AdminRolesEnum } from '../shared/enums/admin-roles.enum';
import { AddPfacComponent } from './components/add-pfac/add-pfac.component';
import { MatDialog } from '@angular/material/dialog';
import { PfacModel, SearchPfacModel } from 'src/app/configuration-pfac/models/configuration-pfac.models';
import { MatTableDataSource } from '@angular/material/table';
import { LoadingService } from '../shared/service/loading.service';
import { ConfigurationPfacService } from './services/configuration-pfac.service';
import { finalize, catchError } from 'rxjs/operators';
import { FdAlertComponent, ModalDefinitions } from '../shared/fd-form-components/fd-alert/fd-alert.component';
import { Messages } from '../shared/messages/messages';
import { DatePipe } from '@angular/common';
import { of } from 'rxjs';

@Component({
  selector: 'app-configuration-pfac',
  templateUrl: './configuration-pfac.component.html',
  styleUrl: './configuration-pfac.component.scss',
  standalone: false
})
export class ConfigurationPfacComponent implements OnInit {

  formGroup: UntypedFormGroup;
  dataSource = new MatTableDataSource<PfacModel>();

  pageNumber = 0;
  size = 10;
  totalItens = 0;
  pageNumberFilter = 0;

  constructor(
    private authService: AuthService,
    private formBuilder: UntypedFormBuilder,
    private dialog: MatDialog,
    private loadingService: LoadingService,
    private configurationPfacService: ConfigurationPfacService,
    private modal: MatDialog,
    private datePipe: DatePipe
  ) { }

  ngOnInit() {
    this.startForms();
    this.getAllGroups(true);
  }

  get hasWriteAccess() {
    return this.authService.isUserInRoles([AdminRolesEnum.CONFIG_ACCREDITATION_PFAC]);
  }

  addPFAC() {
    const dialogRef = this.dialog.open(AddPfacComponent, {
      width: '60%',
      height: '50%',
    });

    dialogRef.afterClosed().subscribe((updated: boolean) => {
      if (updated) {
        this.getAllGroups(true);
      }
    });
  }

  startForms(): void {
    this.formGroup = this.formBuilder.group({
      pfac: [null]
    });
  }

  changePage(event: any) {
    this.size = event.pageSize;
    this.pageNumber = event.pageIndex;
    this.getAllGroups(true);
  }

  getAllGroups(searchWithPageNumber: boolean = false) {
      this.loadingService.show();
  
      this.pageNumberFilter = searchWithPageNumber ? this.pageNumber : 0;
  
      const filtro = new SearchPfacModel();
      filtro.size = this.size.toString();
      filtro.pageNumber = this.pageNumberFilter.toString();
  
      this.configurationPfacService.getAllPageable(filtro)
        .pipe(
          finalize(() => this.loadingService.hide()),
          catchError(error => {
            console.error('Erro ao buscar grupos PFAC:', error);
            this.modal.open(FdAlertComponent, {
              disableClose: true,
              width: ModalDefinitions.DEFAULT_MODAL_WIDTH,
              data: Messages.SEARCH_ERROR
            });
            return of({ response: [], totalItens: 0, page: 0, size: 10 });
          })
        )
        .subscribe({
          next: (pageable) => {
            if (pageable && pageable.response) {
              this.dataSource.data = Array.isArray(pageable.response) ? pageable.response : [];
              this.totalItens = pageable.totalItens || 0;
              this.pageNumber = pageable.page || 0;
              this.size = pageable.size || 10;
            }
          },
          error: (err) => {
            console.error('Erro no subscribe:', err);
            this.dataSource.data = [];
            this.totalItens = 0;
          }
        });
    }

}
